import React from "react";
import AuthService from "../services/auth.service";
import IUser from "../types/user.type";
import UserHome from "../component/user.home";
import AttendanceService from "../services/attendance.service";
import IAttendance from "../types/attendance.type";
import UserLeave from "../component/user.leave";
import UserService from "../services/user.service";
import IResponse from "../types/response.type";
import WorkingTime from "../types/workingtime.type";
import Swal, {SweetAlertOptions} from 'sweetalert2';
import moment from "moment";
import { formatLocalizedDate, formatMonthYear, formatShortDate, t, subscribeLanguage } from "../i18n";
import EventService from "../services/event.service";
import IEvent from "../types/event.type";
import WeatherService from "../services/weather.service";

type Props = {};

type State = {
    isModerator: boolean,
    isAdmin: boolean,
    currentUser: IUser,
    selectMonth: Date,
    date: Date,
    ipv4: string,
    allowIps: string[],
    atWork: boolean,
    curAttendance: IAttendance,
    queryAttendanceDone: boolean,
    queryIpsDone: boolean,
    getConfigDone: boolean,
    todayEvents: IEvent[],
    todayBirthdayUsers: IUser[],
    extremeWeatherAlert: { level: 'hot' | 'cold', temperature: number } | null,
}

export default class Home extends React.Component<Props, State> {
    private unsubscribeLang?: () => void;

    constructor(props: any) {
        super(props);
        const user = AuthService.getCurrentUser();
        this.state = {
            isModerator: false,
            isAdmin: false,
            currentUser: user,
            selectMonth: this.GetStartMonth(user),
            date: new Date(),
            ipv4: '',
            allowIps: [],
            atWork: false,
            curAttendance: {} as IAttendance,
            queryAttendanceDone: false,
            queryIpsDone: false,
            getConfigDone: false,
            todayEvents: [] as IEvent[],
            todayBirthdayUsers: [] as IUser[],
            extremeWeatherAlert: null,
        };
    }

    componentDidMount = () => {
        const user = AuthService.getCurrentUser();
        // const selectMonth = this.getSelectMonth();
        if (user.email != null && user.email != "") {
            UserService.getUser(user.email!).then((u: IUser) => {
                if (u != null && u.active == 1) {
                    this.setState({
                        currentUser: u,
                        selectMonth: this.GetStartMonth(u),
                        isModerator: user.roles == "ROLE_MODERATOR",
                        isAdmin: user.roles == "ROLE_ADMIN",
                    });
                    localStorage.setItem("user", JSON.stringify(u));
                    // console.log(this.state.currentUser);
                } else {
                    AuthService.logout();
                    this.setState({
                        currentUser: {}
                    });
                }
            });
        } else {
            AuthService.logout();
            this.setState({
                currentUser: {}
            });
            window.location.reload();
            return;
        }
        WorkingTime.init(b => {
            this.setState({
                getConfigDone: true,
            });
        });
        setInterval(
            () => this.tick(),
            1000
        );
        let now = new Date();
        if (!this.state.queryAttendanceDone) {
            AttendanceService.getAttendance(user?.email, now.getDate(), now.getMonth() + 1, now.getFullYear()).then(
                (a: IAttendance) => {
                    this.setState({
                        curAttendance: a,
                        queryAttendanceDone: true,
                    });
                    // console.log("home get attendance");
                    if (this.state.queryIpsDone && this.state.atWork && a == null) {
                        this.checkin(true);
                    }
                }
            );
        }
        this.getIP();
        this.loadTodayEvents();
        this.loadTodayBirthdayUsers();
        this.loadExtremeWeatherAlert();
        this.unsubscribeLang = subscribeLanguage(() => this.forceUpdate());
    };

    componentWillUnmount() {
        this.unsubscribeLang?.();
    }

    tick = () => {
        this.setState({
            date: new Date()
        });
    };

    Clock = () => {
        try {
            let x = new Date();
            let x1 = "00:00";
            const wk = this.getWorkingHr();
            const x2 = formatShortDate(x);
            if (wk > 0) {
                return (
                    <div>
                        <div>
                            <h1 id='ct'><span
                                className="text-green"> {new Date(wk * 1000).toISOString().substr(11, 8)}</span></h1>
                            <h4 id='ct2'>{x2}</h4>
                            <>{this.getClockMessage()}</>
                        </div>
                    </div>
                );
            } else {
                x1 = ("0" + x.getHours()).slice(-2) + ":" + ("0" + x.getMinutes()).slice(-2) + ":" + ("0" + x.getSeconds()).slice(-2);
                return (
                    <div>
                        <div>
                            <h1 id='ct'>{x1}</h1>
                            <h4 id='ct2'>{x2}</h4>
                            <>{this.getClockMessage()}</>
                        </div>
                    </div>
                );
            }
        } catch (e) {
        }
    };

    getClockMessage = () => {
        let wtConfig = WorkingTime.getCurrentConfig();
        let x = new Date();
        let lunchTime = new Date(x.getFullYear(), x.getMonth(), x.getDate(), wtConfig.getLunchTime()[0], wtConfig.getLunchTime()[1], 0);
        let afternoonTime = new Date(x.getFullYear(), x.getMonth(), x.getDate(), wtConfig.getAfternoonTime()[0], wtConfig.getAfternoonTime()[1], 0);
        if (lunchTime <= x && x < afternoonTime) {
            return <h5 style={{color: 'green', fontWeight: "bold"}}>{t('home.happyLunch')}</h5>;
        }
        if (this.state.atWork) {
            return <h5 style={{color: 'green', fontWeight: "bold"}}>{t('home.happyWorking')}</h5>;
        }
        const now = new Date();
        const hour = now.getHours();
        const minute = now.getMinutes();
        const currentMinutes = hour * 60 + minute;
        const flexMinutes = wtConfig.getFlexibleMinutes();

        if (currentMinutes < flexMinutes) {
            return <h5 style={{color: 'red', fontWeight: "bold"}}>{t('home.outsideWorkingHours')}</h5>;
        }
        return <h5 style={{color: 'red', fontWeight: "bold"}}>{t('home.outsideOffice')}</h5>;
    };

    getWorkingHr = () => {
        const {curAttendance} = this.state;
        let wtConfig = WorkingTime.getCurrentConfig();
        let x = new Date();
        let lunchTime = new Date(x.getFullYear(), x.getMonth(), x.getDate(), wtConfig.getLunchTime()[0], wtConfig.getLunchTime()[1], 0);
        let afternoonTime = new Date(x.getFullYear(), x.getMonth(), x.getDate(), wtConfig.getAfternoonTime()[0], wtConfig.getAfternoonTime()[1], 0);
        let morningWorkingHr = 0;
        let afternoonWorkingHr = 0;
        if (curAttendance != null && curAttendance.clockin != null && curAttendance.clockin.trim() != "" && curAttendance.clockin.trim().length > 0) {
            const clockin = new Date(curAttendance.clockin!.replace(/-/g, "/"));
            if (clockin < lunchTime) {
                if (x < lunchTime) {
                    morningWorkingHr = (x.getTime() - clockin.getTime()) / 1000;
                } else {
                    morningWorkingHr = (lunchTime.getTime() - clockin.getTime()) / 1000;
                }
            }
            if (clockin > afternoonTime)
                afternoonTime = clockin;
            if (x > afternoonTime) {
                afternoonWorkingHr = (x.getTime() - afternoonTime.getTime()) / 1000;
                if (curAttendance.clockout != null && curAttendance.clockout.trim() != "" && curAttendance.clockout.trim().length > 0) {
                    const clockout = new Date(curAttendance.clockout!.replace(/-/g, "/"));
                    afternoonWorkingHr = (clockout.getTime() - afternoonTime.getTime()) / 1000;
                }
            }
        }
        return morningWorkingHr + afternoonWorkingHr;
    };

    getIP = async () => {
        if (!this.state.queryIpsDone) {
            AuthService.getIp().then(
                (result) => {
                    const ip = result['ip'];
                    const allowIps = result['allow_ips'] as string[];
                    const atWork = allowIps.indexOf(ip) > -1
                        || allowIps.indexOf("0.0.0.0") > -1
                        || allowIps.indexOf("*.*.*.*") > -1;
                    this.setState({
                        ipv4: ip,
                        allowIps: allowIps,
                        atWork: atWork,
                        queryIpsDone: true
                    });
                    // console.log("home getIP");
                    if (atWork && this.state.queryAttendanceDone && this.state.getConfigDone && this.state.curAttendance == null) {
                        this.checkin(true);
                    }
                }
            );
        }
    };

    loadTodayEvents = () => {
        const now = new Date();
        const todayStart = moment().startOf('day');
        const next30DaysEnd = moment(todayStart).add(45, 'days').endOf('day');

        EventService.getAllEvents(now.getMonth() + 1, now.getFullYear()).then((events: IEvent[]) => {
            const upcomingEvents = (events ?? []).filter((event) => {
                if (!this.isImportantEvent(event) || event.type === 'birthday') {
                    return false;
                }

                const startDate = moment(event.start_str).startOf('day');
                const endDate = moment(event.end_str).endOf('day');

                return endDate.isSameOrAfter(todayStart) && startDate.isSameOrBefore(next30DaysEnd);
            });

            this.setState({
                todayEvents: upcomingEvents
            });
        });
    };

    isBirthdayToday = (birthdayRaw?: string) => {
        if (!birthdayRaw || birthdayRaw.trim().length === 0) {
            return false;
        }
        const birthday = new Date(birthdayRaw.replace(/-/g, "/"));
        const now = new Date();
        return birthday.getDate() === now.getDate() && birthday.getMonth() === now.getMonth();
    };

    loadTodayBirthdayUsers = () => {
        UserService.getAllBasicUsers().then((users: IUser[]) => {
            const birthdayUsers = (users ?? []).filter((user) => {
                if (user.active !== 1) {
                    return false;
                }

                const daysUntilBirthday = this.getBirthdayDaysUntil(user.birthday);
                return daysUntilBirthday != null && daysUntilBirthday >= 0 && daysUntilBirthday <= 7;
            });
            this.setState({
                todayBirthdayUsers: birthdayUsers
            });
        });
    };

    loadExtremeWeatherAlert = () => {
        WeatherService.getForecast(1).then((forecast) => {
            const currentTemp = forecast.current?.temperature;
            if (currentTemp == null) {
                this.setState({ extremeWeatherAlert: null });
                return;
            }

            if (currentTemp > 36) {
                this.setState({
                    extremeWeatherAlert: {
                        level: 'hot',
                        temperature: currentTemp,
                    }
                });
                return;
            }

            if (currentTemp < 10) {
                this.setState({
                    extremeWeatherAlert: {
                        level: 'cold',
                        temperature: currentTemp,
                    }
                });
                return;
            }

            this.setState({ extremeWeatherAlert: null });
        }).catch(() => {
            this.setState({ extremeWeatherAlert: null });
        });
    };

    renderExtremeWeatherAlert = () => {
        const { extremeWeatherAlert } = this.state;
        if (!extremeWeatherAlert) {
            return null;
        }

        const isHot = extremeWeatherAlert.level === 'hot';
        const iconClass = isHot ? 'mdi mdi-weather-sunny-alert text-danger' : 'mdi mdi-snowflake text-info';
        const title = isHot ? t('weather.extremeHeatTitle') : t('weather.extremeColdTitle');
        const message = isHot ? t('weather.extremeHeatMessage') : t('weather.extremeColdMessage');

        return (
            <div className="card m-b-15">
                <div className="card-body p-12 d-flex align-items-center" style={{ gap: '10px' }}>
                    <i className={iconClass} style={{ fontSize: '20px' }}></i>
                    <div style={{ flex: 1 }}>
                        <h5 className="card-title m-b-5">{title}</h5>
                        <span>{message} ({Math.round(extremeWeatherAlert.temperature)} C)</span>
                    </div>
                </div>
            </div>
        );
    };

    isImportantEvent = (event: IEvent) => {
        const type = event.type ?? '';
        return type === 'birthday'
            || type === 'holiday'
            || type === 'meeting'
            || type === 'day_off'
            || type === 'team_building'
            || type === 'party_day';
    };

    getNextBirthdayDate = (birthdayRaw?: string) => {
        if (!birthdayRaw || birthdayRaw.trim().length === 0) {
            return null;
        }

        const birthday = moment(birthdayRaw.replace(/-/g, '/'));
        if (!birthday.isValid()) {
            return null;
        }

        const today = moment().startOf('day');
        const nextBirthday = birthday.clone().year(today.year()).startOf('day');

        if (nextBirthday.isBefore(today)) {
            nextBirthday.add(1, 'year');
        }

        return nextBirthday;
    };

    getBirthdayDaysUntil = (birthdayRaw?: string) => {
        const nextBirthday = this.getNextBirthdayDate(birthdayRaw);
        if (!nextBirthday) {
            return null;
        }

        return nextBirthday.diff(moment().startOf('day'), 'days');
    };

    getEventDaysUntil = (event: IEvent) => {
        if (!event.start_str || !event.end_str) {
            return null;
        }

        const todayStart = moment().startOf('day');
        const startDate = moment(event.start_str).startOf('day');
        const endDate = moment(event.end_str).endOf('day');

        if (endDate.isBefore(todayStart)) {
            return null;
        }

        if (startDate.isSameOrBefore(todayStart)) {
            return 0;
        }

        return startDate.diff(todayStart, 'days');
    };

    getCountdownLabel = (daysUntil: number) => {
        if (daysUntil <= 0) {
            return t('home.countdownToday');
        }

        if (daysUntil === 1) {
            return t('home.countdownTomorrow');
        }

        return t('home.countdownInDays').replace('{days}', String(daysUntil));
    };

    formatEventDate = (value?: string | Date) => {
        if (!value) {
            return '';
        }

        const parsedDate = value instanceof Date
            ? moment(value)
            : moment(value, [
                moment.ISO_8601,
                'YYYY-MM-DD HH:mm:ss',
                'YYYY-MM-DDTHH:mm',
                'YYYY-MM-DD',
                'YYYY/MM/DD HH:mm:ss',
                'YYYY/MM/DD'
            ], true);

        if (!parsedDate.isValid()) {
            return '';
        }

        return formatLocalizedDate(parsedDate.toDate(), {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    };

    getEventDateRangeLabel = (start?: string | Date, end?: string | Date) => {
        const startLabel = this.formatEventDate(start);
        const endLabel = this.formatEventDate(end);

        if (!startLabel) {
            return '';
        }

        if (!endLabel || startLabel === endLabel) {
            return startLabel;
        }

        return `${startLabel} - ${endLabel}`;
    };

    getEventPriority = (event: IEvent) => {
        const type = event.type ?? '';
        if (type === 'birthday' || type === 'holiday') {
            return 3;
        }
        return 2;
    };

    getEventVisualMeta = (event: IEvent) => {
        const type = event.type ?? '';
        if (type === 'birthday') {
            return {
                iconClass: 'mdi mdi-cake-variant',
                textClass: 'text-purple',
                badgeClass: 'label label-purple label-rounded',
                levelLabel: type
            };
        }
        if (type === 'holiday') {
            return {
                iconClass: 'mdi mdi-beach',
                textClass: 'text-success',
                badgeClass: 'label label-success label-rounded',
                levelLabel: type
            };
        }
        return {
            iconClass: 'mdi mdi-calendar-check',
            textClass: 'text-info',
            badgeClass: 'label label-info label-rounded',
            levelLabel: type.replace('_', ' ')
        };
    };

    getDefaultEventTitle = (event: IEvent) => {
        switch (event.type) {
            case 'birthday':
                return t('calendar.happyBirthday');
            case 'holiday':
                return t('calendar.holiday');
            case 'day_off':
            case 'weekend':
                return t('calendar.dayOff');
            case 'meeting':
                return t('calendar.meeting');
            case 'team_building':
                return t('calendar.teamBuilding');
            case 'party_day':
                return t('calendar.partyDay');
            default:
                return t('calendar.eventDefault');
        }
    };

    isCurrentUserBirthday = () => {
        return this.isBirthdayToday(this.state.currentUser?.birthday);
    };

    renderTodayEventNotifications = () => {
        const notices: { key: string, title: string, priority: number, daysUntil: number, countdownLabel: string, dateRangeLabel: string, iconClass: string, textClass: string, badgeClass: string, levelLabel: string }[] = [];
        const seen = new Set<string>();
        const birthdayMeta = this.getEventVisualMeta({ type: 'birthday' } as IEvent);

        this.state.todayBirthdayUsers.forEach((user) => {
            const daysUntil = this.getBirthdayDaysUntil(user.birthday);
            if (daysUntil == null || daysUntil < 0 || daysUntil > 7) {
                return;
            }

            const key = `birthday_user_${user.email ?? user.id ?? user.name}`;
            if (seen.has(key)) {
                return;
            }
            seen.add(key);

            const isCurrentUser = !!this.state.currentUser?.email && this.state.currentUser.email === user.email;
            notices.push({
                key,
                title: isCurrentUser ? t('home.todayIsYourBirthday') : `${t('calendar.happyBirthday')}: ${user.name ?? user.email ?? ''}`,
                priority: 3,
                daysUntil,
                countdownLabel: this.getCountdownLabel(daysUntil),
                dateRangeLabel: this.getEventDateRangeLabel(this.getNextBirthdayDate(user.birthday)?.toDate()),
                iconClass: birthdayMeta.iconClass,
                textClass: birthdayMeta.textClass,
                badgeClass: birthdayMeta.badgeClass,
                levelLabel: birthdayMeta.levelLabel,
            });
        });

        const selfBirthdayAlreadyListed = this.state.todayBirthdayUsers.some(
            (user) => !!user.email && user.email === this.state.currentUser?.email
        );

        if (this.isCurrentUserBirthday() && !selfBirthdayAlreadyListed) {
            const selfBirthdayMeta = this.getEventVisualMeta({ type: 'birthday' } as IEvent);
            notices.push({
                key: 'self-birthday',
                title: t('home.todayIsYourBirthday'),
                priority: 3,
                daysUntil: 0,
                countdownLabel: this.getCountdownLabel(0),
                dateRangeLabel: this.getEventDateRangeLabel(this.getNextBirthdayDate(this.state.currentUser?.birthday)?.toDate()),
                iconClass: selfBirthdayMeta.iconClass,
                textClass: selfBirthdayMeta.textClass,
                badgeClass: selfBirthdayMeta.badgeClass,
                levelLabel: selfBirthdayMeta.levelLabel,
            });
        }

        this.state.todayEvents.forEach((event) => {
            const daysUntil = this.getEventDaysUntil(event);
            if (!this.isImportantEvent(event) || daysUntil == null) {
                return;
            }
            const normalizedType = event.type ?? 'event';
            const key = `${normalizedType}_${event.id ?? event.id_str ?? event.title ?? 'event'}`;
            if (seen.has(key)) {
                return;
            }
            seen.add(key);
            const visualMeta = this.getEventVisualMeta(event);
            notices.push({
                key,
                title: (event.title && event.title.trim().length > 0) ? event.title : this.getDefaultEventTitle(event),
                priority: this.getEventPriority(event),
                daysUntil,
                countdownLabel: this.getCountdownLabel(daysUntil),
                dateRangeLabel: this.getEventDateRangeLabel(event.start_str, event.end_str),
                iconClass: visualMeta.iconClass,
                textClass: visualMeta.textClass,
                badgeClass: visualMeta.badgeClass,
                levelLabel: visualMeta.levelLabel,
            });
        });

        notices.sort((a, b) => {
            if (a.daysUntil !== b.daysUntil) {
                return a.daysUntil - b.daysUntil;
            }

            return b.priority - a.priority;
        });

        if (notices.length === 0) {
            return null;
        }

        return (
            <div className="card m-t-10">
                <div className="card-body p-15">
                    <h5 className="card-title m-b-10">{t('home.ongoingEventsTitle')}</h5>
                    <ul className="m-b-0 p-l-0" style={{listStyle: 'none'}}>
                        {notices.map((notice) => (
                            <li key={notice.key} className="m-b-10 d-flex align-items-center" style={{gap: '8px'}}>
                                <i className={notice.iconClass}></i>
                                <div style={{flex: 1}}>
                                    <span className={notice.textClass}>{notice.title}</span>
                                    {notice.dateRangeLabel && <div className="text-muted" style={{fontSize: '12px'}}>{notice.dateRangeLabel}</div>}
                                </div>
                                <span className={notice.badgeClass}>{notice.countdownLabel}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        );
    };

    checkin = (isAuto: boolean) => {
        const {currentUser} = this.state;
        const now = new Date();
        const hour = now.getHours();
        const minute = now.getMinutes();
        const currentMinutes = hour * 60 + minute;

        let wtConfig = WorkingTime.getCurrentConfig();
        const flexMinutes = wtConfig.getFlexibleMinutes();
        if (currentMinutes < flexMinutes) {
            if (!isAuto) {
                Swal.fire({
                    type: "error",
                    title: t('home.oops'),
                    text: t('home.tooEarlyCheckin'),
                    footer: `<a href="tel:0979908827">${t('home.contactAdmin')}</a>`,
                    showConfirmButton: false
                } as SweetAlertOptions);
            }
            return;
        }
        if (!this.state.atWork) {
            Swal.fire({
                type: "error",
                title: t('home.oops'),
                text: t('home.connectNetwork'),
                footer: `<a href="tel:0979908827">${t('home.contactAdmin')}</a>`,
                showConfirmButton: false
            } as SweetAlertOptions);
            return;
        }
        AttendanceService.checkIn(currentUser?.email, isAuto).then(
            (result: IResponse) => {
                if (result.code == 0) {
                    window.location.reload();
                    return;
                }
                Swal.fire({
                    type: "error",
                    title: t('home.oops'),
                    text: result.message!,
                    footer: `<a href="tel:0979908827">${t('home.contactAdmin')}</a>`,
                    showConfirmButton: false
                } as SweetAlertOptions);
            }
        );
    };

    checkout = () => {
        if (!this.state.atWork) {
            Swal.fire({
                type: "error",
                title: t('home.oops'),
                text: t('home.connectNetwork'),
                footer: `<a href="tel:0979908827">${t('home.contactAdmin')}</a>`,
                showConfirmButton: false
            } as SweetAlertOptions);
            return;
        }
        const {currentUser} = this.state;
        AttendanceService.checkOut(currentUser?.email, this.getWorkingHr()).then(
            () => {
                window.location.reload();
                // console.log("home check-out");
            }
        );
    };

    DateHeader = () => {
        let {selectMonth} = this.state;
        return formatMonthYear(selectMonth);
    };

    GetThisMonth = () => {
        const now = new Date();
        return new Date(now.getFullYear(), now.getDate() > 25 ? (now.getMonth() + 1) : now.getMonth(), 1);
    };

    GetStartMonth = (queryUser: IUser) => {
        if (queryUser != null && queryUser.resign_date != null) {
            const resign = new Date(queryUser.resign_date.replace(/-/g, "/"));
            resign.setDate(1);
            return resign;
        }
        return this.GetThisMonth();
    };

    btn_prev_month = () => {
        const {selectMonth, currentUser} = this.state;
        if (selectMonth.getFullYear() == 2022 && selectMonth.getMonth() <= 2)
            return;
        if (currentUser.date_of_joining != null) {
            const join = new Date(currentUser.date_of_joining.replace(/-/g, "/"));
            if (join.getDate() > 25) {
                join.setDate(1);
                join.setMonth(join.getMonth() + 1);
            }
            if (join >= selectMonth)
                return;
        }
        let a = new Date(selectMonth.getFullYear(), selectMonth.getMonth() - 1, 1);
        this.setState({
            selectMonth: a
        });
        this.DateHeader();
    };

    btn_next_month = () => {
        const {selectMonth, currentUser} = this.state;
        if (selectMonth >= this.GetThisMonth())
            return;
        if (currentUser.resign_date != null) {
            const resign = new Date(currentUser.resign_date.replace(/-/g, "/"));
            resign.setMonth(resign.getMonth() - 1);
            resign.setDate(1);
            if (selectMonth > resign)
                return;
        }
        let a = new Date(selectMonth.getFullYear(), selectMonth.getMonth() + 1, 1);
        this.setState({
            selectMonth: a
        });
        this.DateHeader();
    };

    DaysWithCompany = () => {
        const { currentUser } = this.state;
        if (!currentUser?.date_of_joining) return null;
        const joinDate = moment(currentUser.date_of_joining);
        const today = moment();
        const years = today.diff(joinDate, 'years');
        const months = today.diff(joinDate.clone().add(years, 'years'), 'months');
        const days = today.diff(joinDate.clone().add(years, 'years').add(months, 'months'), 'days');
        return { years, months, days };
    };

    ShowButton = () => {
        const {curAttendance, queryAttendanceDone} = this.state;
        if (!queryAttendanceDone) {
            return <></>;
        }
        if (curAttendance == null) {
            return (<button type="button" onClick={() => this.checkin(false)}
                            className="m-t-10 m-b-20 waves-effect waves-dark btn btn-primary btn-md btn-rounded">{t('home.checkIn')}</button>);
        } else if (curAttendance.clockout == null || curAttendance.clockout.trim() == "" || curAttendance.clockout.trim().length == 0) {
            return (<button type="button" data-toggle="modal" data-target="#checkout-modal"
                            className="m-t-10 m-b-20 waves-effect waves-dark btn btn-danger btn-md btn-rounded">{t('home.checkOut')}</button>);
        } else {
            return (<span className="m-t-10 m-b-20 btn-md label label-success label-rounded">{t('home.thankyou')}</span>);
        }
    };

    render() {
        const {currentUser, selectMonth} = this.state;
        return (
            <div className="container-fluid">
                {this.renderExtremeWeatherAlert()}
                {this.renderTodayEventNotifications()}
                <div className="row">
                    <div className="col-lg-4 col-xlg-3 col-md-5">
                        <div className="card">
                            <div className="m-t-30 text-center">
                                <img src={currentUser?.picture} alt={currentUser?.picture} className="img-circle"
                                     width="150"/>
                                <h4 className="card-title m-t-10">{currentUser?.name}</h4>
                                <h5 className="card-subtitle">{currentUser?.title}</h5>
                            </div>
                            {(() => {
                                const dwc = this.DaysWithCompany();
                                if (dwc == null) return null;
                                const segments = [
                                    { value: dwc.years, unit: t('home.yearsUnit'), show: dwc.years > 0 },
                                    { value: dwc.months, unit: t('home.monthsUnit'), show: dwc.months > 0 },
                                    { value: dwc.days, unit: t('home.daysShortUnit'), show: true },
                                ].filter(s => s.show);
                                return (
                                    <div style={{
                                        margin: '16px 16px 0 16px',
                                        borderRadius: '12px',
                                        background: 'linear-gradient(135deg, #f7b733 0%, #f4711a 100%)',
                                        padding: '16px 12px',
                                        textAlign: 'center',
                                        color: '#fff',
                                    }}>
                                        <div style={{ fontSize: '13px', marginBottom: '10px', opacity: 0.9, fontWeight: 500 }}>
                                            {t('home.daysWithCompany')}
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'center', gap: '12px' }}>
                                            {segments.map((s, i) => (
                                                <div key={i} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                    <span style={{ fontSize: '40px', fontWeight: 700, lineHeight: 1 }}>{s.value}</span>
                                                    <span style={{ fontSize: '12px', opacity: 0.85, marginTop: '3px', fontWeight: 500 }}>{s.unit}</span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                );
                            })()}
                            <div>
                                <hr/>
                            </div>
                            <div className="m-t-10 m-b-10 text-center">
                                {this.Clock()}
                                {this.ShowButton()}
                                <div id="checkout-modal" className="modal fade" role="dialog"
                                     aria-labelledby="checkOutModal" aria-hidden="true">
                                    <div className="modal-dialog">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h4 className="modal-title">{t('home.confirmCheckoutTitle')}</h4>
                                                <button type="button" className="close" data-dismiss="modal"
                                                        aria-hidden="true">×
                                                </button>
                                            </div>
                                            <div className="modal-body">
                                                <span>{t('home.confirmCheckoutBody')}</span>
                                            </div>
                                            <div className="modal-footer">
                                                <button type="button" onClick={this.checkout}
                                                        className="btn btn-danger waves-effect waves-light">{t('home.checkOut')}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <UserLeave selectMonth={selectMonth} email={currentUser.email!}/>
                    </div>
                    <div className="col-lg-8 col-xlg-9 col-md-7">
                        <div className="card">
                            <div className="card-body p-0">
                                <div className="bg-light-warning p-l-20 p-r-20">
                                    <div className="fc-toolbar fc-header-toolbar">
                                        <div className="fc-left">
                                            <button type="button"
                                                    className="fc-prev-button fc-button fc-state-default fc-corner-left"
                                                    onClick={this.btn_prev_month}><span
                                                className="mdi mdi-chevron-left"></span></button>
                                        </div>
                                        <div className="fc-center">
                                            <h2 id="date_header" className="text-info2">{this.DateHeader()}</h2>
                                        </div>
                                        <div className="fc-right">
                                            <button type="button"
                                                    className="fc-next-button fc-button fc-state-default fc-corner-right"
                                                    onClick={this.btn_next_month}><span
                                                className="mdi mdi-chevron-right"></span></button>
                                        </div>
                                        <div className="fc-clear"></div>
                                    </div>
                                </div>
                                <UserHome selectMonth={selectMonth} queryUser={currentUser} time={"month"}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}